/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Mcp_Server_Development_TitleInputs */

const en_svc_mcp_server_development_title = /** @type {(inputs: Svc_Mcp_Server_Development_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MCP Server Development`)
};

const ar_svc_mcp_server_development_title = /** @type {(inputs: Svc_Mcp_Server_Development_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تطوير خوادم MCP`)
};

const bn_svc_mcp_server_development_title = /** @type {(inputs: Svc_Mcp_Server_Development_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MCP সার্ভার ডেভেলপমেন্ট`)
};

const de_svc_mcp_server_development_title = /** @type {(inputs: Svc_Mcp_Server_Development_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MCP-Server-Entwicklung`)
};

const es_svc_mcp_server_development_title = /** @type {(inputs: Svc_Mcp_Server_Development_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desarrollo de servidores MCP`)
};

const fr_svc_mcp_server_development_title = /** @type {(inputs: Svc_Mcp_Server_Development_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Développement de serveurs MCP`)
};

const pt_svc_mcp_server_development_title = /** @type {(inputs: Svc_Mcp_Server_Development_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desenvolvimento de servidores MCP`)
};

const zh_svc_mcp_server_development_title = /** @type {(inputs: Svc_Mcp_Server_Development_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MCP 服务器开发`)
};

const tr_svc_mcp_server_development_title = /** @type {(inputs: Svc_Mcp_Server_Development_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MCP Sunucu Geliştirme`)
};

const ru_svc_mcp_server_development_title = /** @type {(inputs: Svc_Mcp_Server_Development_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Разработка MCP-серверов`)
};

const pl_svc_mcp_server_development_title = /** @type {(inputs: Svc_Mcp_Server_Development_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Budowa serwerów MCP`)
};

/**
* | output |
* | --- |
* | "MCP Server Development" |
*
* @param {Svc_Mcp_Server_Development_TitleInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_mcp_server_development_title = /** @type {((inputs?: Svc_Mcp_Server_Development_TitleInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Mcp_Server_Development_TitleInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_mcp_server_development_title(inputs)
	if (locale === "bn") return bn_svc_mcp_server_development_title(inputs)
	if (locale === "de") return de_svc_mcp_server_development_title(inputs)
	if (locale === "es") return es_svc_mcp_server_development_title(inputs)
	if (locale === "fr") return fr_svc_mcp_server_development_title(inputs)
	if (locale === "pt") return pt_svc_mcp_server_development_title(inputs)
	if (locale === "zh") return zh_svc_mcp_server_development_title(inputs)
	if (locale === "tr") return tr_svc_mcp_server_development_title(inputs)
	if (locale === "ru") return ru_svc_mcp_server_development_title(inputs)
	if (locale === "pl") return pl_svc_mcp_server_development_title(inputs)
	return en_svc_mcp_server_development_title(inputs)
});
export { svc_mcp_server_development_title as "svc_mcp-server-development_title" }